

export function rearrangeArrayWithLock(arr) {
  // Filter the array to get only the objects with lock: true
  const lockedObjects = arr.filter((obj) => obj.lockPosition);
  // Sort the filtered objects based on their value
  //lockedObjects.sort((a, b) => a.value - b.value);

  // Remove locked objects from the array
  arr = arr.filter((obj) => !obj.lockPosition);

  // Add sorted locked objects back to the array at the specified index
  // Sort in descending order to insert from end to beginning, preventing position shifts
  lockedObjects
    .sort((a, b) => Number(b?.lockPositionNumber) - Number(a?.lockPositionNumber))
    .forEach((obj) => {
      arr.splice(Number(obj.lockPositionNumber), 0, obj);
    });

  return arr;
}

export const dateFormate = (date) =>{
  const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(date));
  return formattedDate;
}




